export const CREATE_PLAN_QUERY_PARAMS = Object.freeze({
  CLONE_FROM_PLAN_ID: 'cloneFromPlanId',
});
